export const SITE = {
  brand: "Deleg Admin",
  slogan: "Vous posez les carreaux. On gère le reste.",
  zone: "Toute la France",
  email: "delegadmin@gmail.com",
  phone: "06 68 48 49 25",
  calendly: "https://calendly.com/delegadmin/30min",
  year: new Date().getFullYear(),
};
